var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeKeepLogoHorizontalDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 392.6 72.1",
    style: {
      enableBackground: "new 0 0 392.6 72.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1B1C1F;}\n\t.st1{display:none;}\n\t.st2{display:inline;opacity:0.2;fill:#00D2B7;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#00D2B7;}\n\t.st5{fill:#343A4D;}\n\t.st6{fill:none;}\n\t.st7{fill:none;stroke:#343A4D;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:#1D202B;}\n\t.st9{fill:#353A4D;}\n\t.st10{fill:#4A4A4A;}\n\t.st11{fill:#BDBDBD;}\n\t.st12{fill:#FFFFFF;stroke:#1C1C1C;stroke-miterlimit:10;}\n\t.st13{fill:#00EDDC;}\n\t.st14{fill:#F88E8E;}\n\t.st15{fill:#F6C563;}\n\t.st16{fill:#00ACFF;}\n\t.st17{fill:#00D8F1;}\n\t.st18{fill:#0082BE;}\n\t.st19{fill:#231F20;}\n\t.st20{fill:#0065A1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.7,29.4c-4.5-0.1-7.8,2.9-8.5,7.8h16.5C241.5,32.3,238.4,29.4,233.7,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M140.7,30.3c-5.7,0-9.9,4.5-9.9,10.4s4.2,10.5,9.9,10.5c5.5-0.1,9.9-4.6,9.9-10.5 C150.6,34.9,146.4,30.3,140.7,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M331.9,27.3c-6.2,0-10.7,4.2-11.4,11h22.4C342.5,31.4,338.2,27.3,331.9,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,27.3c-6.2,0-10.8,4.2-11.4,11h22.4C308.1,31.4,303.8,27.3,297.4,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M366.7,27.4c-7.1,0-12.5,5.9-12.5,13.8c0.1,7.7,5.3,13.3,12.4,13.3c7.1-0.1,11.6-5.4,11.6-13.9 C378.3,32.6,373.8,27.4,366.7,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.5,23.4c-4.7,0-8.7,2.4-11.3,6.7c0.1-3.3,0.1-6.7,0.1-10.2v-8h-7.7v44.6h7.7V40.9 c0-6.4,3.4-10.6,8.5-10.6c4.5,0,6.7,2.5,6.7,8.6v17.6h7.7V36C119.2,27.9,114.9,23.4,107.5,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M140.7,23.4c-10.2,0-17.7,7.5-17.7,17.2s7.6,17.2,17.7,17.3c10.1,0,17.6-7.6,17.6-17.3 C158.3,30.9,150.8,23.4,140.7,23.4z M140.7,51.1c-5.6,0-9.9-4.6-9.9-10.5s4.2-10.4,9.9-10.4s9.9,4.6,9.9,10.4 C150.6,46.5,146.2,51,140.7,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.3,23.4c-4.5,0-8.9,2.4-11.6,7.7c-1.3-5-4.8-7.7-10.1-7.7c-4.6,0-8.1,2.4-10.8,6.7v-5.4h-7.6v31.7h7.7 V41.2c0-6.4,3.3-11,7.7-11c4,0,6.2,2.6,6.2,8.7v17.6h7.7V41.2c0-6.4,3.3-11,7.6-11c4.1,0,6.2,2.6,6.2,8.7v17.6h7.7V36 C213.2,27.9,208.9,23.4,202.3,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.7,23.4c-9.8,0-16.6,7-16.6,17.3c0,10.1,6.7,17.2,16.9,17.2c6.8,0,12-3,15-8.6l-5.9-2.8l-0.7,0.1 c-2.1,3.4-4.7,5.1-8.3,5.1c-5.2,0-9.1-3.6-9.1-9.3V42v-0.1h24.5c0.1-0.6,0.1-0.9,0.1-1.3C249.7,29.8,243.2,23.4,233.7,23.4z  M225.3,37.2c0.7-4.9,3.9-7.9,8.5-7.8c4.7,0,7.8,2.9,8.1,7.8H225.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M279.4,25.4h-4.9l-6.6,6.4c-3.2,3-6.3,6.2-9.5,9.2V22V11.9h-3.6v44.6h3.6V45.2l5.9-5.6l12.9,17h4.5 l-14.9-19.2L279.4,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M297.4,24c-9,0-15.4,6.8-15.4,17c0,10.1,6.4,16.9,15.7,16.9c6.2,0,11.1-2.9,14.1-8.2l-2.6-1.8l-0.4,0.1 c-2.7,4.4-6.2,6.5-10.8,6.5c-6.8,0-12.1-4.9-12.1-12.7v-0.5v-0.1h26.3c0.1-0.4,0.1-0.6,0.1-1C312.2,30.1,306.4,24,297.4,24z  M286,38.3c0.7-6.7,5.3-11,11.4-11c6.4,0,10.7,4.2,11,11H286z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M331.9,24c-9,0-15.4,6.8-15.4,17c0,10.1,6.4,16.9,15.7,16.9c6.2,0,11.1-2.9,14.1-8.2l-2.6-1.8l-0.4,0.1 c-2.7,4.4-6.2,6.5-10.8,6.5c-6.8,0-12.1-4.9-12.1-12.7v-0.5v-0.1h26.3c0.1-0.4,0.1-0.6,0.1-1C346.7,30.1,340.8,24,331.9,24z  M320.5,38.3c0.7-6.7,5.3-11,11.4-11c6.4,0,10.7,4.2,11,11H320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M367.5,24c-5.6,0-10.5,3.1-13,8.4v-7h-3.6h0v46.7h3.6V60.1V49.8c2.1,4.9,7.4,8.1,12.7,8.1 c8.9,0,15-7.1,15-17.3C382.1,30.7,376.2,24,367.5,24z M366.6,54.5c-7.1,0-12.3-5.6-12.4-13.3c-0.1-7.9,5.3-13.8,12.5-13.8 s11.6,5.1,11.6,13.2C378.3,49.1,373.8,54.4,366.6,54.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "16.9,25.7 16.9,0 0,0 0,68.2 16.9,68.2 16.9,42.5 48.2,42.5 56.6,34.2 48.2,25.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "48.2,68.2 65.1,68.2 65.1,42.5 56.6,34.2 48.2,42.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "48.2,25.7 56.6,34.2 65.1,25.7 65.1,0 48.2,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "384.6,52.9 385.8,52.9 385.8,56.5 386.4,56.5 386.4,52.9 387.6,52.9 387.6,52.2 384.6,52.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "391.7,52.2 390.5,55.4 389.2,52.2 388.3,52.2 388.3,56.5 388.9,56.5 388.9,53.2 390.3,56.5  390.7,56.5 392,53.2 392,56.5 392.6,56.5 392.6,52.2  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeKeepLogoHorizontalDark);
export default __webpack_public_path__ + "static/media/HomeKeep-Logo-horizontal-dark.51baf5e0e774a939ba03ff076f2d7c65.svg";
export { ForwardRef as ReactComponent };